import CreateShippingLabel from './ui/createShippingLabel/createShippingLabel';

export default CreateShippingLabel;
